import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {OtpType} from "../../../enums/otp-types.enum";
import {LocalStorageKey, SalesWorkflow} from "projects/store/src/app/enums";
import {Category} from 'projects/store/src/app/enums';
import {RequestService} from "../../../services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import { faPenNib } from '@fortawesome/free-solid-svg-icons';
import {CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess, UtilService, CountdownTimerService, CountdownTick} from "library";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {PixelService} from "projects/store/src/app/services/api/v1/pixel.service";
import {UserData, Workflow} from "projects/store/src/app/interfaces";
import {NotificationOtpService} from 'projects/store/src/app/services/api/v1/notification-otp.service';
import {OtpServiceType} from 'projects/store/src/app/enums/otp-service-types.enum';

enum ViewState {
  Ready,
  Error
}

/**
 * Componente principal de Revisión de Contrato
 * Contiene toda la lógica común para V2 y V3
 * Actúa como container que renderiza la versión correcta según el flujo
 */
@Component({
  selector: 'app-sales-review-contract',
  templateUrl: './sales-review-contract.component.html',
})
export class SalesReviewContractComponent implements OnInit, OnDestroy {

  form: FormGroup;
  formCode: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  requestId: string;
  categoryCode!: string;
  request: any = {};
  agreementHTML: string = '';
  sentCode!: boolean;
  visibleCodeModal = false;
  code!: string;
  otpType = OtpType.agreement;
  maxRetries = 3;
  currentRetries = 0;
  userData!: UserData;
  workflow!: Workflow;
  errorMessage!: string;
  visibleErrorModal: boolean = false;
  visibleErrorIDModal: boolean = false;
  visibleSigningManualModal: boolean = false;
  error!: Error;
  ViewState = ViewState;
  viewState: ViewState = ViewState.Ready;
  visibleFirstSentCodeMessageModal!: boolean;
  visibleAttentionModal!: boolean;
  visibleRetriesSentCodeMessageModal!: boolean;
  visibleSigningModal!: boolean;
  faPenNib = faPenNib;
  scrollEl!: HTMLDivElement;
  timeNewCodeSending!: { minutes: number, seconds: number };
  maxTimeToRetry: { minutes: number, seconds: number };
  private countdownSub: any;
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Firma del contrato'];
  messageOtpService!: string;
  messageOtpServiceFirstSend!: string;
  showOtpServiceModal = false;
  selectedOtpService!: string;
  otpServicesOptions: any[] = [];
  otpServiceType: string = '';
  flowCode: string;
  // Propiedades para los 4 dígitos del código OTP
  codeDigits: string[] = ['', '', '', ''];

  @Output() nextStepEvent = new EventEmitter();

  constructor(
    protected requestService: RequestService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected utilService: UtilService,
    protected customMessageService: CustomMessageService,
    protected localStorageService: LocalStorageService,
    protected salesWorkflowService: SalesWorkflowService,
    protected metaPixelService: PixelService,
    protected notificationOtpService: NotificationOtpService,
    protected countdownTimer: CountdownTimerService
  ) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.form = new FormGroup({
      code: new FormControl(null, [Validators.required, Validators.minLength(4)]),
      acept_conditions: new FormControl(null, [Validators.requiredTrue]),
    });

    this.formCode = new FormGroup({
      document: new FormControl(null, [Validators.required]),
    });
    this.maxTimeToRetry = { minutes: 2, seconds: 0 }
    this.request = this.requestService.request;
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.userData = localStorageService.get(LocalStorageKey.data);
  }

  /**
   * Determina si el flujo actual es Krdya (V3)
   */
  get isFlowKrdya(): boolean {
    return this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }

  showGetOtpOptions() {
    this.notificationOtpService.get().subscribe({
      next: (resp: any) => {
        this.otpServicesOptions = resp;
        this.selectedOtpService = this.requestService.request['person']?.otp_service ?? this.otpServicesOptions[0]?.value;
        const otpDetail = this.notificationOtpService.getDetailOtp(this.selectedOtpService);
        this.messageOtpService = otpDetail?.message ?? '';
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.comunicationError();
      }
    });
  }

  isTheEndOfAgreement() {
    if (!this.scrollEl) {
      return false;
    }
    let limit = Math.ceil(this.scrollEl.scrollHeight - (this.scrollEl.scrollHeight * 0.02));
    let current = Math.ceil(this.scrollEl.scrollTop) + this.scrollEl.clientHeight;
    return current >= limit;
  }

  ngOnInit() {
    // Container: la inicialización se delega a los hijos (V2/V3)
  }

  load() {
    this.utilService.enablePageLoading();
    this.requestService.getAgreement(this.requestId).subscribe({
      next: (resp)=>{
        if(resp.status === HttpStatusCode.Ok) {
          this.agreementHTML = resp.body.data.html
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
        this.isNotKredicashFlow();
      },
      error: (error)=>{
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
    });
  }

  showOptionesSend() {
    this.visibleSigningModal = false;
    this.showOtpServiceModal = true;
  }

  onSelectedOtpServiceAndSend(flag: boolean) {
    this.showOtpServiceModal = false;

    const otp_service: string = this.selectedOtpService ?? '';
    this.messageOtpService = this.notificationOtpService.getDetailOtp(this.selectedOtpService ?? '').message;

    this.sendCode(flag, otp_service);
  }

  sendCode(isRetry: boolean, otp_service: string) {
    this.loading = true;
    this.utilService.enablePageLoading();

    this.requestService.sendSingingAgreementCode(this.requestId, isRetry, otp_service).subscribe({
      next: (resp: any) => {
        if (resp.status === HttpStatusCode.NoContent) {
          this.sentCode = true;
        } else {
          this.sentCode = false;
        }
        this.startTime();
        if (this.categoryCode === Category.kredicash && this.shouldShowEmergencyDisbursementAlert()) {
          this.visibleAttentionModal = true;
        } else {
          this.closeAllModals();
          if (isRetry) {
            this.visibleSigningModal = true;
          } else {
            this.visibleFirstSentCodeMessageModal = true;
          }
        }
        this.loading = false;
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.sentCode = false;
          this.loading = false;
          if (this.categoryCode === Category.kredicash && this.shouldShowEmergencyDisbursementAlert()) {
            this.visibleAttentionModal = true;
          } else {
            this.closeAllModals();
            if (isRetry) {
              this.visibleRetriesSentCodeMessageModal = true;
            } else {
              this.visibleFirstSentCodeMessageModal = true;
            }
          }
          this.startTime();
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.utilService.disablePageLoading();
      }
    });
  }

  closeAttentionModal() {
    this.visibleAttentionModal = false;
    this.visibleFirstSentCodeMessageModal = true;
  }

  onSearchCode() {
    this.loading = true;
    this.submitted = true;

    if (this.formCode.invalid) {
      this.formCode.markAllAsTouched();
      this.loading = false;
      return;
    }

    const data = {
      document_number: this.formCode.get('document')?.value,
      type: this.otpType
    };

    this.requestService.getCode(this.requestId, data).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.code = resp.body?.data?.code || null;
          this.visibleSigningManualModal = true;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }

        this.loading = false;
        this.submitted = false;
      },
      error: (error: ResponseHttpError) => {
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.visibleErrorIDModal = true;
        }else{
          this.customMessageService.responseNoticeHandler(error);
          this.loading = false;
        }
      }
    });
  }

  signing() {
    this.submitted = true;
    this.loading = true;
    if (this.form.invalid) {
      return;
    }

    this.requestService.checkSingingAgreementCode(this.requestId, this.form.value.code).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.metaPixelService.trackEvent('Subscribe');
          this.onNextStep();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loading = false;
      },
      error: (error: ResponseHttpError) => {
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.form.controls['code'].setErrors({invalid: true});
          this.visibleSigningModal = false;
          this.viewState = ViewState.Error;
          this.visibleErrorModal = true;
        }else{
          this.customMessageService.responseNoticeHandler(error);
          this.loading = false;
        }
        this.loading = false;
      }
    });
  }

  onRetryID() {
    this.visibleErrorIDModal = false;
    this.loading = false;
    this.visibleCodeModal = true;
  }

  startTime() {
    this.countdownTimer.stop();
    const isNotKredicash = this.isNotKredicashFlow();
    if (isNotKredicash){
      this.maxTimeToRetry = { minutes: 0, seconds: 20 };

    }else{
      this.maxTimeToRetry = { minutes: 2, seconds: 0 };
    }
    this.timeNewCodeSending = { ...this.maxTimeToRetry };
    // Cancelar suscripción previa si existe
    this.countdownSub?.unsubscribe?.();
    // Iniciar servicio con la duración configurada
    this.countdownTimer.startWithDuration(this.maxTimeToRetry);
    // Suscribir a los ticks
    this.countdownSub = this.countdownTimer.tick$.subscribe((tick: CountdownTick) => {
      this.timeNewCodeSending = { ...tick };
    });
  }

  showModal() {
    this.visibleSigningModal = false;
    this.visibleAttentionModal = false;
    this.visibleFirstSentCodeMessageModal = false;
    this.visibleCodeModal = true;
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  getCanCancelRequest(): boolean {
    return this.salesWorkflowService.canCancelRequest();
  }

  isNotKredicashFlow() {
    return this.salesWorkflowService.workflow.code !== SalesWorkflow["kredicash-cliente"];
  }

  vieValidateButtonWithDocument(){
    return this.userData?.store?.setting?.enabled_view_otp_by_document ?? false;
  }

  shouldShowEmergencyDisbursementAlert(): boolean {
    // Solo para kredicash-express, verificamos el setting emergency_disbursement_alert
    // Para otros flujos de kredicash, mantenemos el comportamiento actual (siempre mostrar el modal)
    if (this.salesWorkflowService.workflow?.code === SalesWorkflow['kredicash-express']) {
      return this.salesWorkflowService.currentStep?.setting?.emergency_disbursement_alert?.value ?? false;
    }
    return true;
  }

  get f() {
    return this.form.controls;
  }

  get fc() {
    return this.formCode.controls;
  }

  builtMsgSendFirstCode(): string {
    switch (this.otpServiceType) {
      case OtpServiceType.WHATSAPP:
        return `Hemos enviado un <strong>WhatsApp</strong> a tu teléfono.`;
      case OtpServiceType.LLAMADA:
        return `Vamos a realizar una <strong>LLAMADA</strong> a tu teléfono.`;
      case OtpServiceType.SMS:
      default:
        return `Hemos enviado un <strong>SMS</strong> a tu teléfono.`;
    }
  }

  closeAllModals() {
    this.visibleSigningModal = false;
    this.visibleAttentionModal = false;
    this.visibleFirstSentCodeMessageModal = false;
    this.visibleRetriesSentCodeMessageModal = false;
  }

  /**
   * Maneja el input de cada dígito del código OTP
   * Auto-focus al siguiente input y actualiza el código completo
   */
  onDigitInput(event: any, index: number): void {
    const input = event.target;
    const value = input.value;

    // Solo permitir números
    if (value && !/^\d$/.test(value)) {
      input.value = '';
      return;
    }

    this.codeDigits[index] = value;
    this.updateFullCode();

    // Auto-focus al siguiente input si hay valor
    if (value && index < 3) {
      const nextInput = document.getElementById(`digit${index + 2}`);
      nextInput?.focus();
    }
  }

  /**
   * Maneja el evento keydown para backspace
   * Permite borrar y volver al input anterior
   */
  onDigitKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !this.codeDigits[index] && index > 0) {
      const prevInput = document.getElementById(`digit${index}`);
      prevInput?.focus();
    }
  }

  /**
   * Maneja el evento paste para pegar el código completo
   */
  onDigitPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 4);

    for (let i = 0; i < 4; i++) {
      this.codeDigits[i] = digits[i] || '';
    }
    this.updateFullCode();

    // Focus en el último input con valor o el siguiente vacío
    const lastFilledIndex = Math.min(digits.length, 3);
    const targetInput = document.getElementById(`digit${lastFilledIndex + 1}`);
    targetInput?.focus();
  }

  /**
   * Actualiza el campo code del formulario con los 4 dígitos combinados
   */
  private updateFullCode(): void {
    const fullCode = this.codeDigits.join('');
    this.form.patchValue({ code: fullCode.length === 4 ? fullCode : null });
  }

  /**
   * Verifica si el código está completo (4 dígitos)
   */
  isCodeComplete(): boolean {
    return this.codeDigits.every(digit => digit !== '');
  }

  ngOnDestroy() {
    this.countdownSub?.unsubscribe?.();
    this.countdownTimer.stop();
  }
}
